import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuth } from '@contexts/AuthContext';
import { useVoiceRecordings } from '@contexts/VoiceRecordingsContext';
import { RecordVoice } from '@features/voice-recordings/record-voice/index.';
import { VoiceRecordingList } from '@features/voice-recordings/voice-recording-list';
import { Box, CircularProgress } from '@mui/material';
import { useEffect, useRef } from 'react';
export const VoiceRecordingContainer = () => {
    const hasInitialized = useRef(false);
    const { isLoading: isAuthLoading } = useAuth();
    const { isLoading, hasValidRecordings, initializeVoiceRecordings } = useVoiceRecordings();
    useEffect(() => {
        // Only initialize once
        if (hasInitialized.current)
            return;
        const initialize = async () => {
            hasInitialized.current = true;
            initializeVoiceRecordings();
        };
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsx(_Fragment, { children: isAuthLoading || isLoading ? (_jsx(Box, { flex: 1, display: "flex", justifyContent: "center", alignItems: "center", children: _jsx(CircularProgress, {}) })) : (_jsxs(_Fragment, { children: [" ", hasValidRecordings ? _jsx(VoiceRecordingList, {}) : _jsx(RecordVoice, {})] })) }));
};
